module.exports = __webpack_public_path__ + "assets/media/sampleAudio1.5a9a9118.mp3";